import user from "@/data/forms/mixins/user.js";
import master from "@/data/forms/mixins/master.js";
import basic from "@/data/forms/mixins/basic.js";
import char from "@/data/forms/mixins/char.js";
import stats from "@/data/forms/mixins/stats.js";
import pref from "@/data/forms/mixins/pref.js";
import link from "@/data/forms/mixins/link.js";

export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  // eslint-disable-next-line
  mixins: [
    user,
    master,
    basic,
    char,
    stats,
    pref,
    link
  ],
  methods: {
    generateUserForm() {
      let k = this.formUser;
      k.basic = this.formBasicUser; // basic
      k.char = this.formCharUser; // characteristics
      k.pref = this.formPrefUser; // characteristics
      k.pref.select = this.formUserSelect; // what was selected
      k.stats = this.formStatsUser; // stats
      k.rev = null; // to be populated duirng doc creation
      return k;
    },
    generateCompanyForm() {
      let k = this.formCompany;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharCompany; // characteristics
      k.pref = this.formPrefCompany; // characteristics
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsCompany; // stats
      return k;
    },
    generateFacilityForm() {
      let k = this.formFacility;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharFacility; // characteristics
      k.pref = this.formPrefFacility; // characteristics
      k.link = this.formLinkPlanBudgetRisk; // characteristics
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsFacility; // stats
      return k;
    },
    generateAssetForm() {
      let k = this.formAsset;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharAsset; // characteristics
      k.link = this.formLinkAssetEquipmentRisk;
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsAsset; // stats
      // roles are not required is it is simply [].
      return k;
    },
    generateAccessForm() {
      let k = this.formAccess;
      k.basic = this.formBasicAccess; // basic
      k.char = this.formCharAccess; // characteristics
      k.select = this.formUserSelect;
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsItem; // stats
      // roles are not required is it is simply [].
      return k;
    },
    generateAttachmentForm() {
      let k = this.formAttachment;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharAttachment; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generatePartsForm() {
      let k = this.formParts;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharParts; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateResourcesForm() {
      let k = this.formResources;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharResources; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateAnalysisForm() {
      let k = this.formAnalysis;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharAnalysis; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateMaintActivityForm() {
      let k = this.formMaintActivity;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharMaintActivity; // characteristics
      k.stats = this.formStatsMaintActivity; // references
      return k;
    },
    generateInventoryForm() {
      let k = this.formListEmbeddedItem;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharInventory; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateResultsForm() {
      let k = this.formResults;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharEngineeringResults; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateMaintCallForm() {
      let k = this.formMaintCall;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharMaintCall; // characteristics
      k.link = this.formLinkMaintPlan; // dates and counters
      k.stats = this.formStatsMaintCall; // references
      k.rev = null; // to be populated duirng doc creation
      return k;
    },
    generateLimitsForm() {
      let k = this.formLimits;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharLimit; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generatePermitsForm() {
      let k = this.formPermits;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharPermit; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateTasksForm() {
      let k = this.formPermits;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharTask; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateRiskAnalysisForm() {
      let k = this.formRiskAnalysis;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharRiskAnalysis; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateRiskAssessmentForm() {
      let k = this.formRiskAssessment;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharRiskAssessment; // characteristics
      k.stats = this.formStatsItem; // references
      return k;
    },
    generateDocumentLogForm() {
      let k = this.formDocumentLog;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharDocumentLog; // characteristics
      k.stats = this.formStatsItem; // characteristics
      k.rev = null; // to be populated
      return k;
    },
    generateNotificationForm() {
      let k = this.formNotification;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharNotification; // characteristics
      k.link = this.formLinkAsset;
      k.stats = this.formStatsNotification; // characteristics
      return k;
    },
    generateProcedureForm() {
      let k = this.formProcedure;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharProcedure; // characteristics
      k.link = this.formLinkFacilityEquipment;
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsProcedure; // dates and counters
      return k;
    },
    generateProgramForm() {
      let k = this.formProgram;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharProgram; // characteristics
      k.link = this.formLinkFacilityEquipment;
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsProgram; // dates and counters
      return k;
    },
    generateOrderForm() {
      let k = this.formOrder;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharOrder; // characteristics
      k.link = this.formLinkFacilitySourceBudget;
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsOrder; // dates and counters
      k.trans = null; // to be populated duirng doc creation
      return k;
    },
    generateActionForm() {
      let k = this.formAction;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharAction; // characteristics
      k.link = this.formLinkGeneralSourceAssetFacilityCompany;
      k.rev = null; // to be populated duirng doc creation
      k.trans = null; // to be populated duirng doc creation
      k.stats = this.formStatsAction; // stats
      return k;
    },
    generateEngineeringForm() {
      let k = this.formEngineering;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharEngineering; // characteristics
      k.link = this.formLinkEngineeringRequest; // appended doc.

      k.rev = null; // to be populated duirng doc creation
      k.trans = null; // to be populated
      k.stats = this.formStatsEngineering; // stats
      return k;
    },
    generateReportForm() {
      let k = this.formReport;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharReport; // characteristics
      k.link = this.formLinkReport; // appended doc.
      k.stats = this.formStatsReport;
      k.rev = null; // to be populated duirng doc creation
      return k;
    },
    generateWorkRequestForm() {
      let k = this.formWorkRequest;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharWork; // characteristics
      k.stats = this.formStatsWork; // dates and counters
      k.link = this.formLinkWorkRequest; // dates and counters
      return k;
    },
    generateWorkCallForm() {
      let k = this.formWorkCall;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharWork; // characteristics
      k.stats = this.formStatsWork; // dates and counters
      k.link = this.formLinkWorkCall; // dates and counters
      return k;
    },
    generateEquipmentForm() {
      let k = this.formEquipment;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharEquipment; // characteristics
      k.link = this.formLinkFacility; // technc1al info
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsEquipment; // stats
      // roles are not required is it is simply [].
      return k;
    },
    generateMaterialForm() {
      let k = this.formMaterial; // template
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharMaterial; // characteristics
      k.link = this.formLinkFacilityEquipmentBudget;
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsMaterial; // stats
      return k;
    },
    generateRiskForm() {
      let k = this.formRisk;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharRisk; //nc1al info
      k.link = this.formLinkGeneralAssetFacility; // appended doc.
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsIncidentRisk; // stats
      k.trans = null; // to be populated
      return k;
    },
    generateBudgetForm() {
      let k = this.formBudget;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharBudget; // characteristics
      k.link = this.formLinkFacilityPlan;
      k.rev = null; // to be defined later
      k.stats = this.formStatsBudget; // stats
      k.trans = null; // to be deined later
      return k;
    },
    generateHazardForm() {
      let k = this.formHazard; // template
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharHazard; // characteristics
      k.link = this.formLinkFacility;
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsHazard; // stats
      return k;
    },
    generateIncidentForm() {
      let k = this.formIncident;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharIncident; // characteristics
      k.link = this.formLinkGeneralAssetFacility; // appended doc.
      k.rev = null; // to be populated duirng doc creation
      k.trans = null; // to be populated
      k.stats = this.formStatsIncidentRisk; // stats
      return k;
    },
    generatePlanForm() {
      let k = this.formPlan;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharPlan; // characteristics
      k.link = this.formLinkFacilityBudget; // appended doc.
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsPlan; // stats
      k.trans = null;
      // roles are not required is it is simply [].
      return k;
    },
    generateMaintPlanForm() {
      let k = this.formPlan;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharMaintPlan; // characteristics
      k.link = this.formLinkMaintPlan; // dates and counters
      k.rev = null; // to be populated duirng doc creation
      k.stats = this.formStatsMaintPlan; // stats
      k.trans = null;
      // roles are not required is it is simply [].
      return k;
    },
    generateMaintStrategyForm() {
      let k = this.formMaintStrategy;
      k.basic = this.formBasicGeneral; // basic
      k.char = this.formCharMaintStrategy; // characteristics
      k.link = this.formLinkFacilityEquipment; // dates and counters
      k.rev = null; // to be generated
      k.stats = this.formStatsMaintStrategy; // stats
      k.trans = null; // to be generated
      return k;
    }
  }
};
